//地图使用的坐标类型
type CoordType = 'WGS84' | 'GCJ02' | 'BD09'
export const coordType: CoordType = 'WGS84'
//监控地带
export const monitorAreaColor: string = '#066d3f'
//保护范围
export const protectAreaColor: string = '#f0190e'
//巡查点
export const patrolAreaColor: string = '#0f0fff'
//重点保护范围
export const keyProtectAreaColor: string = '#ff7fff'
//巡查轨迹
export const cruiseTrackColor: string = '#00f029'
//文保单位中是否显示四有信息
export const showUnitFour: boolean = true
export interface configData {
  DateFormat: string,//日期
  DateTimeFormat: string,//日期+时分
  DateTimessFormat: string,//日期+时分秒
  PageSize: number,
  PopPageSize: number,//弹窗单页记录数
  ChartDeviceNum: number,
  ApiDomain: string, //正式环境的域名
  DevDomain: string, //测试环境的域名
  Version: string,
  SiteName: string,
  Copyright: string,//版权
  ICPNo: string,//备案号
  ICPUrl: string,//备案网址
  /**登陆时是否隐藏菜单,默认true */
  HiddenMenu: boolean,
  /**是否显示坐标检测按钮,默认false */
  ShowCoordCheck: boolean,
  /**是否显示首页6大块按钮 */
  ShowQuickAccess: boolean,
  AppUrl: string//app下载地址
  WebControl: webControlData
  BaiduMap: baiduMapData
  UseH5Player: boolean
}
//海康视频控件配置项
export interface webControlData {
  Appkey: string
  SecretKey: string
  IP: string
  Port: number
  /**是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示 */
  showSmart: number
}
export interface baiduMapData {
  ak: string
  styleId: string
}
export const _config: configData = {
  DateFormat: 'yyyy-MM-dd',
  DateTimeFormat: 'yyyy-MM-dd hh:mm',
  DateTimessFormat: 'yyyy-MM-dd hh:mm:ss',
  PageSize: 20,
  PopPageSize: 50,
  ChartDeviceNum: 3,//3个设备为一组

  DevDomain: 'http://localhost:5005',//开发环境 本地api
  //DevDomain: 'http://testapi.hpmanage.com',//开发环境
  //DevDomain: 'http://erdosapi.ordostour.cn',
  ApiDomain: 'http://testapi.hpmanage.com',//生产环境
  SiteName: '测试库',
  Version: 'v2.0',
  Copyright: 'Copyright @ 2018-' + (new Date).getFullYear() + ' 上海通超信息科技有限公司',
  ICPNo: '沪ICP备18029320号-1',
  ICPUrl: 'https://beian.miit.gov.cn/',
  //app 下载地址
  AppUrl: 'https://api.hpmanage.com/apk/CruiseAPP',

  HiddenMenu: true,
  ShowCoordCheck: false,
  /**河南true */
  ShowQuickAccess: false,
  /** 首页视频播放使用使用 h5 player */
  UseH5Player: false,
  // 海康通用平台
  WebControl: {
    Appkey: "22981425",
    SecretKey: "poQBWx3qBl3qiMBJCdVc",
    IP: "8.142.7.114",
    Port: 1443,
    showSmart: 0
  },
  // 鄂尔多斯海康平台
  // WebControl: {
  //   Appkey: "24060116",
  //   SecretKey: "zxFM0nrKnzVG5dJf06AA",
  //   IP: "116.136.156.134",
  //   Port: 1443,
  //   showSmart: 0
  // },
  BaiduMap: {
    ak: 'fLCzo41B9KjGEZl0HrSMLFbmFhqgLojs',
    styleId: ''//'0168c6aa92981cec6171f88dfd172dcf' // 不设置id，使用json样式
  }
}
